module.exports = __webpack_public_path__ + "static/inclusion.beb0396e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/awards_ceremony/inclusion.png
// module id = 555
// module chunks = 138584234813021